import React from 'react'

import { Flex, Box, Text, Image, Button } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import { vacationBearSvg, owlTutorPenSheetSvg } from '../../assets'

type Props = {
  login: string
  isCurrentUser: boolean
}

const ProfileIncomplete: React.FC<Props> = ({ login, isCurrentUser }) => {
  return (
    <Flex flexDirection="column" alignItems="center">
      {isCurrentUser ? (
        <>
          <Image src={vacationBearSvg} alt="" mb="3x" />
          <Text variant="text.h4" mb="3x">
            {t('This profile is not fully completed yet!')}
          </Text>
          <Button
            onClick={() =>
              (window.location.href = `/community/new-topic?category=tutor-introductions`)
            }
            type="primaryAdvanced"
          >
            {t('Fill out your new profile')}
          </Button>
        </>
      ) : (
        <>
          <Image src={owlTutorPenSheetSvg} alt="" mb="3x" />
          <Text variant="text.h4" mb="1x">
            {t('Welcome %{login} to the community!', { login })}
          </Text>
          <Text variant="text.paragraph" mb="3x">
            {t('As a new tutor, their profile is not fully completed yet.')}
          </Text>
          <Box mb="1x">
            <Button
              onClick={() =>
                (window.location.href = `/community/new-message?username=${login}`)
              }
              type="primaryAdvanced"
            >
              {t('Ask this tutor a question directly')}
            </Button>
          </Box>
          <Button
            onClick={() => (window.location.href = `/community/g/tutors`)}
            type="primaryAdvanced"
            fill="outline"
          >
            {t('Discover more Tutors')}
          </Button>
        </>
      )}
    </Flex>
  )
}

export default ProfileIncomplete
